import { Dialog, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { FirewallService } from "../../services/api";
import {
  CreateRecordBodyTypeEnum,
  FirewallRecord,
} from "../../services/swagger";
import FormInput from "../molecules/FormInput";
import useRefresh from "../../hooks/useRefresh";
import FormTemplate from "../templates/FormTemplate";
import useEnums from "../../hooks/useEnums";
import { useTranslation } from "react-i18next";
import useConfirm from "../../hooks/useConfirm";
import useBreakpoint from "../../hooks/useBreakpoint";
import DeleteIcon from "@mui/icons-material/Delete";

interface EditRecordDialogProps {
  record?: FirewallRecord;
  onSubmit?: () => void;
  onClose?: () => void;
}

export default function EditRecordDialog(props: EditRecordDialogProps) {
  const { record } = props;
  const { t } = useTranslation("EditRecordDialog");
  const refresh = useRefresh();
  const { recordTypeDropDownItems } = useEnums();
  const [ip, setIP] = useState("");
  const [prefix, setPrefix] = useState("");
  const [type, setType] = useState<CreateRecordBodyTypeEnum>("blacklist");

  const breakpoint = useBreakpoint();
  const confirm = useConfirm();

  useEffect(() => {
    if (!record) return;
    setIP(record.ip);
    setPrefix(String(record.prefix));
    setType(record.type);
  }, [record]);

  const handleSubmit = async () => {
    if (!record?._id) return;
    const res = await FirewallService.updateRecord({
      id: record._id,
      updateRecordBody: {
        ip: ip.trim(),
        prefix: Number(prefix),
        type,
      },
    });
    if (res?.data?.success) {
      refresh();
      props.onClose?.();
    }
  };

  const handleDelete = () => {
    confirm(async () => {
      if (!record?._id) return;
      const res = await FirewallService.deleteRecord({
        id: record._id,
      });
      if (res?.data?.success) {
        refresh();
        props.onClose?.();
      }
    });
  };

  return (
    <Dialog
      fullScreen={!breakpoint.sm}
      open={Boolean(record)}
      onClose={props.onClose}
    >
      <FormTemplate
        title={t("EditRecord")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
        options={[
          {
            icon: <DeleteIcon color="error" />,
            label: t("DeleteRecord"),
            onClick: handleDelete,
          },
        ]}
      >
        <Stack spacing={2}>
          <FormInput
            field="type"
            label={t("Type")}
            onChange={(v) => {
              setType(v as CreateRecordBodyTypeEnum);
            }}
            type="list"
            required
            value={type}
            list={recordTypeDropDownItems}
          />
          <FormInput
            label={t("IP.Label")}
            value={ip}
            placeholder={t("IP.Placeholder")}
            required
            field="ip"
            type="string"
            onChange={(v) => {
              if (typeof v === "string") setIP(v);
            }}
          />
          <FormInput
            label={t("Prefix.Label")}
            field="prefix"
            type="number"
            value={prefix}
            placeholder={t("Prefix.Placeholder")}
            required
            onChange={(v) => {
              if (typeof v === "string" || typeof v === "number")
                setPrefix(String(v));
            }}
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
